<form [formGroup]="searchForm">
  <mat-form-field class="mph-input">
    <input #searchInput
      type="text"
      placeholder="What are you looking for?"
      aria-label="Search"
      matInput
      formControlName="searchTerm"
      [matAutocomplete]="auto">
      <mat-autocomplete #autocomplete #auto="matAutocomplete" (optionSelected)='navigate($event.option.value)'>
        @for (product of filteredProducts | async; track product) {
          <mat-option [value]="product.title">
            {{product?.title}}
          </mat-option>
        }
      </mat-autocomplete>
      <button (click)="search()" class="search-btn" matSuffix mat-icon-button aria-label="Search">
        <mat-icon class="search-icon">search</mat-icon>
      </button>
    </mat-form-field>
  </form>
